import React from 'react';
import { BrowserRouter, useNavigate } from 'react-router-dom';

// auth provider
import { JWTProvider as AuthProvider } from './contexts/JWTContext';
import { NotificationProvider } from './contexts/NotificationContext';
import CustomToast from './common/CustomToast';
import { setGlobalNavigate } from './util/navigation';

import routes, { renderRoutes } from './routes';

const NavigationBinder = () => {
  const navigate = useNavigate();
  React.useEffect(() => {
    setGlobalNavigate(navigate);
  }, [navigate]);
  return null;
};

const App = () => {
  return (
    <React.Fragment>
      <NotificationProvider>
        <BrowserRouter basename={process.env.REACT_APP_BASE_NAME}>
          <NavigationBinder />
          <AuthProvider>{renderRoutes(routes)}</AuthProvider>
        </BrowserRouter>
        {/* Triggering HMR */}
        <CustomToast />
      </NotificationProvider>
    </React.Fragment>
  );
};

export default App;
